import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PTs from 'prop-types';
import React from 'react';

import {
  faUserCircle,
  faUser,
} from '@fortawesome/free-regular-svg-icons';

import {
  faUserTie,
  faUserGraduate,
  faUserAstronaut,
} from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Link from '../../../components/Link';
import PageLayout from '../../../components/PageLayout';

import HighSchoolStudentsSection from './HighSchoolStudentsSection';
import CollegeStudentsSection from './CollegeStudentsSection';
import HobbyistsSection from './HobbyistsSection';
import AmateursSection from './AmateursSection';
import ExpertsSection from './ExpertsSection';

import s from './DemographicsPage.scss';

class DemographicsPage extends React.Component {
  static propTypes = {
    section: PTs.oneOf([
      'high-school-students',
      'college-students',
      'hobbyists',
      'amateurs',
      'experts',
    ]),
  };

  static defaultProps = {
    section: 'high-school-students',
  };

  render() {
    const { section } = this.props;
    return (
      <PageLayout className={s.page}>
        <section className="layout">
          <div className={s.content}>
            <nav className={s.demographicsNav}>
              <div className={s.navTitle}>Demographics</div>
              <Link
                className={s.navLink}
                to="/demographics/high-school-students"
              >
                <FontAwesomeIcon icon={faUserCircle} />
                High School Students
              </Link>
              <Link className={s.navLink} to="/demographics/college-students">
                <FontAwesomeIcon icon={faUserGraduate} />
                College Students
              </Link>
              <Link className={s.navLink} to="/demographics/hobbyists">
                <FontAwesomeIcon icon={faUser} />
                Hobbyists
              </Link>
              <Link className={s.navLink} to="/demographics/amateurs">
                <FontAwesomeIcon icon={faUserTie} />
                Amateurs
              </Link>
              <Link className={s.navLink} to="/demographics/experts">
                <FontAwesomeIcon icon={faUserAstronaut} />
                Experts
              </Link>
            </nav>

            <div className={s.section}>
              {section === 'high-school-students' && (
                <HighSchoolStudentsSection />
              )}
              {section === 'college-students' && <CollegeStudentsSection />}
              {section === 'hobbyists' && <HobbyistsSection />}
              {section === 'amateurs' && <AmateursSection />}
              {section === 'experts' && <ExpertsSection />}
            </div>
          </div>
        </section>
      </PageLayout>
    );
  }
}

export default withStyles(s)(DemographicsPage);
